var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 10h-8.75C25.56 10 25 9.44 25 8.75V0H6.875A1.87 1.87 0 0 0 5 1.866v36.259A1.87 1.87 0 0 0 6.866 40h26.259A1.87 1.87 0 0 0 35 38.134V10z",
    fill: "#EDF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.808 30.078c-.524-.602-1.29-1.02-2.155-1.177a19.765 19.765 0 0 0-3.888-.315c-1.111-1.131-2.185-2.466-2.919-3.932.642-2.132.981-3.976 1.172-5.014a1.88 1.88 0 0 0-.393-1.52 1.677 1.677 0 0 0-1.292-.62h-.002c-.482 0-.891.199-1.184.574-.98 1.257-.31 4.3-.165 4.898.148.607.358 1.197.617 1.77-.509 1.615-1.195 3.37-2.123 5.03-3.098 1.138-4.944 2.703-5.095 2.835-.515.504-.769 1.01-.756 1.505.008.28.108.694.541 1.075.332.292.757.438 1.188.438.438 0 .883-.15 1.244-.45 1.496-1.24 2.694-2.78 3.656-4.414a18.295 18.295 0 0 1 5.061-.977 28.548 28.548 0 0 0 3.617 2.97c.916.633 2.14.551 2.911-.194.722-.698.708-1.626-.035-2.482zM12.992 34.18c-.29.245-.717.262-.968.036-.097-.087-.147-.167-.149-.237-.002-.058.024-.277.394-.647.027-.024 1.239-1.07 3.356-2.082-.754 1.08-1.626 2.078-2.633 2.93zm6.07-15.298c.07-.082.144-.132.307-.132.233 0 .385.13.454.208.144.16.205.38.165.585-.16.8-.414 2.072-.833 3.582a14.824 14.824 0 0 1-.036-.131c-.347-1.325-.594-3.477-.057-4.112zm-.937 10.493c.5-1.045.919-2.102 1.269-3.125.542.91 1.183 1.758 1.856 2.53-1.126.114-2.17.326-3.125.595zm9.817 2.17c-.39.407-1.027.441-1.511.082a29.86 29.86 0 0 1-2.681-2.252c.814.041 1.658.14 2.53.309.634.123 1.186.44 1.553.894.475.587.264.806.11.967z",
    fill: "#E56353",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.453 8.203 26.805.547A1.875 1.875 0 0 0 25.477 0H25v8.75c0 .69.56 1.25 1.25 1.25H35v-.477c0-.495-.197-.97-.547-1.32z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4A99F9",
    width: 20,
    height: 12,
    rx: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.052 3.5c.85 0 1.471.164 1.862.491.39.327.586.832.586 1.513 0 .681-.2 1.18-.598 1.497-.399.316-1.01.474-1.834.474h-.996v1.65h-.947V3.5h1.927zm5.603 0c.994 0 1.76.246 2.293.736.535.491.802 1.174.802 2.049 0 .874-.259 1.566-.778 2.075-.518.51-1.312.765-2.38.765H7.75V3.5h1.905zm8.095 0-.008.885H14.95V5.93h2.494v.877H14.95v2.318H14V3.5h3.75zm-8.127.877h-.936v3.855h1.04c.671 0 1.186-.162 1.543-.487.357-.325.536-.803.536-1.437 0-1.287-.728-1.93-2.183-1.93zm-5.588-.016h-.963v2.253h1.1c.524 0 .882-.1 1.072-.301.19-.202.285-.497.285-.886 0-.388-.12-.663-.362-.825-.24-.16-.618-.24-1.132-.24z",
    fill: "#FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePdf);
export default __webpack_public_path__ + "static/media/icon-file-pdf.dd8cbb88.svg";
export { ForwardRef as ReactComponent };